const questionReponse = [
    {
        id:1,
        question: 'A quoi sert le site Trash Buster',
        reponse:'L\'idée de la plateforme Trash Buster est de créer une plateforme pour réunir les initiatives de nettoyage, collecte des déchets abandonnés dans l\'espace public ou la nature. \n L\'objectif est de réunir sur une même plateforme les actions de clean walking et permettre également d\'agir collectivement, ainsi on peut participer à une opération de nettoyage organisée par une autre personne. \n Ensemble agissons '
    },
    {
        id:2,
        question: 'Qui peut participer',
        reponse:'Les participants autorisés à créer une action et participer aux actions de recyclages sont les particuliers, les associations reconnue loi de 1901, les écoles. \nAucune activité économique ne peut être retirée des actions proposés.'
    },
    {
        id:3,
        question: 'Comment mesurer la quantité de déchets',
        reponse:'La quantité de déchets est à indiquer à la louche, vous pouvez vous aider du type de déchets pour estimer. \n Par exemple une majorité de cartons/papiers sera volumineux mais pèsera moins qu\'un tas de ferrail/verre/bois. \n A noter que une pile de livre peut très vitre être lourde. '
    },
    {
        id:4,
        question: 'Participer à une action est-elle gratuite',
        reponse:'L\'essence du site est de créer une communauté pour agir face aux déchets abandonnés dans nos espaces publics et espaces naturels. \n Toutes les actions sont gratuites et ne doivent en aucun cas donner lieu à une quelconque participation finanicère de quelques façons.'
    },

]

export default questionReponse